import React from 'react';

const FacebookHoverBlueLogo = ({ ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.33333 16H9.18182V8.84375H11.3939L11.7576 6H9.18182V4.03125C9.18182 3.59375 9.24242 3.25 9.42424 3.03125C9.60606 2.78125 10 2.65625 10.5455 2.65625H12V0.125C11.4545 0.0625 10.7273 0 9.87879 0C8.78788 0 7.93939 0.34375 7.30303 1C6.63636 1.65625 6.33333 2.5625 6.33333 3.75V6H4V8.84375H6.33333V16Z"
      fill="#2277D1"
    />
  </svg>
);

export default FacebookHoverBlueLogo;
